export default __webpack_public_path__ + "static/media/LOGOlight.9b789a9f.png";